import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import { environment } from "@env/environment";
import {ListaPlano} from "../models/lista-plano";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class PlanoService {
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`PlanoService`);
  }

  baseUrl = environment.apiUrl;

  selecionarLista(): Observable<BaseResponse<ListaPlano> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<ListaPlano>>(`${this.baseUrl}/Plano`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarLista')));
  }

  selecionarPorIdTipoSaas(tipoSaas: number): Observable<BaseResponse<ListaPlano> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<ListaPlano>>(`${this.baseUrl}/Plano/BuscarPorIdTipoSaas/${tipoSaas}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarPorIdTipoSaas')));
  }

  selecionarListaPorSaas(saas: string): Observable<BaseResponse<ListaPlano> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<ListaPlano>>(`${this.baseUrl}/Plano/BuscarPorSaas/${saas}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarListaPorSaas')));
  }
}
